import Head from 'next/head';
import { useEffect } from 'react';
import Aboutusbaner from '../../components/aboutus/aboutusbaner';
import AboutCorporate from '../../components/aboutus/aboutcorporate';
import Drivesolution from '../../components/aboutus/drivesolution';
import Missionvision from '../../components/aboutus/missionvision';
import CampusRank from '../../components/aboutus/campusrank';
import Aboutcontent from '../../components/aboutus/aboutcontent';
import AboutusDigitial from '../../components/aboutus/aboutusdigitial';
import Contactuscoman from '@/components/contactus/contactuscommon';
import { getGuestLogDetailsApi } from '@/components/action/easycampus';



export default function Aboutus() {
  const pageMetaData = {
    pageTitle: 'About Us : Easycampus About Us page',
    pageDescription: 'World',
  };

  useEffect(() => {
    handleGestLogUserData();

  }, []);

  const handleGestLogUserData = async () => {
    try {
      let data = {
        pageName:"About Us"
      }
      const res = await getGuestLogDetailsApi(data);
      return;
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <>
      <Head>
        <title>End-To-End Campus Recruitment Software by EasyCampus</title>
        <meta property="og:type" content="website" />
        <meta name="description" content={"Our comprehensive platform and unified process provides an opportunity to complete the frictionless end-to-end campus hiring process without any geographical barrier to all the stakeholder’s"} />
        <meta property="og:title" content={"Our comprehensive platform and unified process provides an opportunity to complete the frictionless end-to-end campus hiring process without any geographical barrier to all the stakeholder’s"} />
        <meta name="description" content={"Our comprehensive platform and unified process provides an opportunity to complete the frictionless end-to-end campus hiring process without any geographical barrier to all the stakeholder’s"} />
        <meta name="keywords" content={"campus solution"} />
        <meta property="og:url" content={"www.easycampus.in"} />
        <meta property="og:description" content={"Our comprehensive platform and unified process provides an opportunity to complete the frictionless end-to-end campus hiring process without any geographical barrier to all the stakeholder’s"} />
        <meta property="og:image" content={'https://ec-images.s3.ap-south-1.amazonaws.com/easycampus-logo-for-video.png'} />
      </Head>
      <main className="flex min-h-screen flex-col w-[100%]">
        <div className="w-full mx-auto relative">
          <div className='bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] opacity-40 from-[#51A9FF] to-transparent rounded-full h-96 w-[750px] z-0 blur-lg absolute top-3/4 -left-4 -translate-x-1/2 -translate-1/2'></div>
          <Contactuscoman />
          <Aboutusbaner />
          <AboutCorporate />
          <Drivesolution />
          <Missionvision />
          <CampusRank />
          <Aboutcontent />
          <AboutusDigitial />
        </div>
      </main>

    </>
  );
}